import qs from 'qs';
import { parseGetRecsModelsResponse } from '@/search-for-retail/recs-model/recs-model.parsers';
import { formatRecsModel } from '@/search-for-retail/recs-model/recs-model.formatters';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Shared tag helpers
// ---------------------------------------------------------------------------
// eslint-disable-next-line max-len
const invalidateListByCollection = (_result, _error, { collection }) => [{ type: CC_API_TAGS.RecsModelList, id: collection }];
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for the Recommendations Model API.
 *
 * Endpoints sit under `/recommendation/models/{collection}`.
 * Auth and tenant headers are handled by the base `ccApi`.
 */
export const recsModelApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        // -----------------------------------------------------------------------
        // Queries
        // -----------------------------------------------------------------------
        getRecsModelList: builder.query({
            query: ({ collection, page, perPage: size, filter, }) => {
                const queryParams = qs.stringify({
                    page,
                    size,
                    searchTerm: filter === null || filter === void 0 ? void 0 : filter.name,
                });
                return `/recommendation/models/${collection}?${queryParams}`;
            },
            transformResponse: (response) => parseGetRecsModelsResponse(response),
            providesTags: (_result, _error, { collection }) => [
                { type: CC_API_TAGS.RecsModelList, id: collection },
            ],
        }),
        getRecsModelById: builder.query({
            query: ({ collection, id }) => `/recommendation/models/${collection}/${id}`,
            providesTags: (_result, _error, { collection, id }) => [
                { type: CC_API_TAGS.RecsModel, id: `${collection}-${id}` },
            ],
        }),
        // -----------------------------------------------------------------------
        // Mutations
        // -----------------------------------------------------------------------
        createRecsModel: builder.mutation({
            query: ({ collection, data, perPage }) => {
                const queryParams = qs.stringify({ customPageSize: perPage });
                return {
                    url: `/recommendation/models/${collection}?${queryParams}`,
                    method: 'POST',
                    body: formatRecsModel(data),
                };
            },
            transformResponse: (response, meta) => {
                var _a, _b;
                return ({
                    recsModel: response,
                    locationPage: ((_b = (_a = meta === null || meta === void 0 ? void 0 : meta.response) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.get('x-groupby-location-page')) || null,
                });
            },
            invalidatesTags: invalidateListByCollection,
        }),
        updateRecsModel: builder.mutation({
            query: ({ collection, data }) => ({
                url: `/recommendation/models/${collection}/${data.id}`,
                method: 'PUT',
                body: formatRecsModel(data),
            }),
            invalidatesTags: (_result, _error, { collection, data }) => [
                { type: CC_API_TAGS.RecsModelList, id: collection },
                { type: CC_API_TAGS.RecsModel, id: `${collection}-${data.id}` },
            ],
        }),
        deleteRecsModel: builder.mutation({
            query: ({ collection, id }) => ({
                url: `/recommendation/models/${collection}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: invalidateListByCollection,
        }),
    }),
});
export const { useGetRecsModelListQuery, useLazyGetRecsModelListQuery, useGetRecsModelByIdQuery, useLazyGetRecsModelByIdQuery, useCreateRecsModelMutation, useUpdateRecsModelMutation, useDeleteRecsModelMutation, } = recsModelApi;
